import { defineComponent as _defineComponent } from 'vue'

import { computed, defineComponent, onMounted, watchEffect } from 'vue'
import { useRoute } from 'vue-router/composables'

import SignUpForm from '@/components/onboarding/signUp/SignUpForm.vue'
import OnboardingScreen from '@/components/onboarding/OnboardingScreen.vue'
import { useOnboardingStore } from '@/stores/onboarding'
import { logEvent } from '@/utils/utility-manager'
import { useAuth } from '@/composables/auth'

const __default__ = defineComponent({
  components: {
    SignUpForm,
    OnboardingScreen,
  },
  layout: 'centered',
  head() {
    return {
      title: this.$t('lambusAllInOneApp') as string,
    }
  },
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'sign-up',
  setup(__props) {

const onboardingStore = useOnboardingStore()
const route = useRoute()
const auth = useAuth()

onboardingStore.previousAuthenticatingRoutePath = '/sign-up'

onMounted(() => {
  logEvent('sign_up_page_viewed')
})

const useCenteredLayout = computed(() => {
  return (
    typeof route.query.newTrip === 'string' ||
    typeof route.query.inspirationId === 'string' ||
    typeof route.query.pinCode === 'string' ||
    typeof route.query.assistant_sid === 'string' ||
    route.query.utm_source === 'onboarding' ||
    (auth.isSignedIn && auth.accountType === 'anonymous')
  )
})

watchEffect(() => {
  if (typeof route.query.assistant_sid === 'string') {
    onboardingStore.activateAssistantSession(route.query.assistant_sid)
  } else {
    onboardingStore.activeAssistantSessionHandle = null
    onboardingStore.activeAssistantSession = null
  }
})

return { __sfc: true,onboardingStore, route, auth, useCenteredLayout, SignUpForm, OnboardingScreen }
}

})